export default __webpack_public_path__ + "static/media/money-back.e29426b4.png";